import axios, { AxiosResponse, AxiosError } from 'libs/axios';
import { useMutation, useQuery } from 'react-query';
import { CreateTemplateData, Template } from 'types/template';
import { TEMPLATE_QUERY_KEY } from './query-keys';

export const useAddTemplate = () => {
    return useMutation<AxiosResponse, AxiosError, CreateTemplateData>(
        async (data) => {
            return axios.put(`/api/ui/templates`, data);
        }
    );
};

export const useDeleteTemplates = () => {
    return useMutation<void, AxiosError, { name: string }[]>(
        async (templates) => {
            for (const template of templates) {
                await axios.delete(
                    `/api/ui/templates/${encodeURIComponent(template.name)}`
                );
            }
        }
    );
};

interface EditTemplate {
    originalName: string;
    template: CreateTemplateData;
}

interface TemplateSaveResponse {
    name: string;
    warning: string;
}

export const useEditTemplate = () => {
    return useMutation<
        AxiosResponse<TemplateSaveResponse>,
        AxiosError,
        EditTemplate
    >(async ({ originalName, template }) => {
        const response = await axios.post<TemplateSaveResponse>(
            `/api/ui/templates/${encodeURIComponent(originalName)}`,
            template
        );

        return response;
    });
};

export const useGetTemplate = (name: string) => {
    return useQuery<Template, AxiosError>(
        [TEMPLATE_QUERY_KEY, name],
        async () => {
            const response = await axios.get<Template>(
                `/api/ui/templates/${encodeURIComponent(name)}`
            );

            return response.data;
        }
    );
};
